import * as Models from 'models';

// https://share.merck.com/pages/viewpage.action?spaceKey=GCC&title=Document+State
export const isDocumentDeletedLocally = (document: Models.DocumentMap): boolean => {
  return document.get('isEdited') && !!document.get('number') && !document.get('version');
};
